import { useState } from 'react';

export function SettingsView({ household, onLeave, showToast }) {
  const [copied, setCopied] = useState(false);

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(household.code);
      setCopied(true);
      showToast('Code kopiert!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      showToast('Kopieren fehlgeschlagen');
    }
  };

  return (
    <div className="content">
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Einstellungen</h2>

      {/* Haushalt Info */}
      <div className="settings-card">
        <div className="settings-label">Haushalt</div>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>
          {household.name}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
          <div className="settings-label" style={{ margin: 0 }}>Code:</div>
          <code style={{
            background: 'var(--gray-100)',
            padding: '4px 10px',
            borderRadius: 6,
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: 2
          }}>
            {household.code}
          </code>
          <button className="btn btn-sm btn-outline" onClick={handleCopyCode}>
            {copied ? '✓' : '📋'}
          </button>
        </div>
        <p style={{ fontSize: 13, color: 'var(--gray-400)', marginTop: 8 }}>
          Teile diesen Code mit anderen, damit sie dem Haushalt beitreten können.
        </p>
      </div>

      {/* App Info */}
      <div className="settings-card">
        <div className="settings-label">So funktioniert's</div>
        <div style={{ fontSize: 14, color: 'var(--gray-600)', lineHeight: 1.6 }}>
          <p><strong>1. Beleg hochladen</strong> — Lade den PDF-Kassenbeleg aus der Rewe-App hoch oder füge den Text manuell ein.</p>
          <p style={{ marginTop: 8 }}><strong>2. Produkte prüfen</strong> — Die AI erkennt die Produkte und schätzt die Haltbarkeit.</p>
          <p style={{ marginTop: 8 }}><strong>3. Kühlschrank nutzen</strong> — Sieh auf einen Blick was du hast und was bald abläuft.</p>
          <p style={{ marginTop: 8 }}><strong>4. Rezept erstellen</strong> — Wähle Zutaten aus, kopiere den Text und frag eine KI nach einem Rezept!</p>
        </div>
      </div>

      {/* PWA Install Hint */}
      <div className="settings-card">
        <div className="settings-label">Als App installieren</div>
        <p style={{ fontSize: 14, color: 'var(--gray-600)', lineHeight: 1.5 }}>
          Auf dem iPhone: Teilen-Menü → "Zum Home-Bildschirm". Auf Android: Menü → "App installieren" oder "Zum Startbildschirm hinzufügen".
        </p>
      </div>

      {/* Logout */}
      <button
        className="btn btn-danger btn-block"
        style={{ marginTop: 16 }}
        onClick={() => {
          if (confirm('Möchtest du den Haushalt wirklich verlassen? Deine lokalen Daten werden gelöscht.')) {
            onLeave();
          }
        }}
      >
        Haushalt verlassen
      </button>

      <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--gray-400)', marginTop: 24 }}>
        FridgeBuddy v1.0 · Made with 🧊
      </p>
    </div>
  );
}
